import {useSelector} from "react-redux";
import {UserRoleEnum} from "../helpers/enums";

const useSimpleCaseData = () => {
  const user = useSelector((state) => state.auth);
  const contracts = useSelector((state) => state.contracts);
  const profile = user.impersonationActive ? user.profileImpersonate : user.profile;
  const initialData = profile.role !== UserRoleEnum.MUNICIPAL_OPERATOR ? {
    ...profile,
    ...((profile.role !== UserRoleEnum.PRIVATE || profile.businessName === '') && {businessName: `${profile.name} ${profile.surname}`}),
  } : {};

  return {
    emptyContracts: contracts.length === 0,
    data: initialData,
    blockCaseIfNoContract: UserRoleEnum.MUNICIPAL_OPERATOR ?false: contracts.length === 0
  }
}

export default useSimpleCaseData;
